import type { QueryOptions } from '@apollo/client';

import type { Extension } from './graphql/types';
import { transformPreFilteredExtensions } from './hooks/lib/transformForgeExtensions';
import type {
	PreFilteredExtensionsVariables,
	PrefilteredExtensionsResult,
	UsePreFilteredExtensionsQueryOptions,
} from './hooks/useExtensionList';
import { createUsePrefilteredExtensionListQueryOptions } from './hooks/usePrefilteredExtensionList';
import { FetchPreFilteredForgeAppsQuery } from './hooks/lib/queries';

export const preloadPrefilteredExtensionList = async (
	query: (
		options: QueryOptions<PreFilteredExtensionsVariables>,
	) => Promise<{ data: PrefilteredExtensionsResult | null }>,
	{
		cloudId,
		context,
		includeHidden,
		locale,
		types,
		queryOptions,
	}: UsePreFilteredExtensionsQueryOptions,
): Promise<Extension[] | null> => {
	const requestOptions =
		createUsePrefilteredExtensionListQueryOptions<UsePreFilteredExtensionsQueryOptions>(
			cloudId,
			context,
			undefined,
			types,
			locale,
			includeHidden,
			queryOptions,
		);

	const { data } = await query({
		query: FetchPreFilteredForgeAppsQuery,
		...requestOptions,
	});

	const extensions = (data?.confluence_forgeExtensionsByType || []) as Extension[];
	if (extensions.length > 0) {
		return transformPreFilteredExtensions(extensions);
	}
	return null;
};
